import { View } from 'foundations-components/components/View';
import { PROGRESS_BAR_BORDER_RADIUS, PROGRESS_BAR_HEIGHT } from '../../constants/MediaTimelinePositioning';
import { jsx as _jsx } from "react/jsx-runtime";
export const MediaPlayerBar = ({
  children,
  backgroundColor,
  inlineSize
}) => {
  return /*#__PURE__*/_jsx(View, {
    position: "absolute",
    insetBlockStart: "8px",
    insetInlineStart: "0",
    inlineSize: inlineSize,
    blockSize: PROGRESS_BAR_HEIGHT,
    borderRadius: PROGRESS_BAR_BORDER_RADIUS,
    backgroundColor: backgroundColor,
    overflow: "hidden",
    children: children
  });
};